export default __webpack_public_path__ + "static/media/sim-verdon.ef843791.jpg";